import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './RoadsideContactRoadside.module.scss';

const ContactRoadside = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const title = data?.title || '';
  const phoneLabel = data?.phoneLabel || '';
  const phoneNumber = data?.phoneNumber || '';
  const websiteLabel = data?.websiteLabel || '';
  const websiteUrl = data?.websiteUrl || '';
  const websiteText = data?.websiteText || '';

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: title }} />
        <p className={styles.content_subtext}>{phoneLabel}</p>
        <p className={styles.content_text}>
          <a href={`tel:${String(phoneNumber).replace(/\s/g, '')}`}>{phoneNumber}</a>
        </p>
        <p className={styles.content_subtext}>{websiteLabel}</p>
        <p className={styles.content_text}>
          <a href={websiteUrl} rel="noreferrer" target="_blank">
            {websiteText}
          </a>
        </p>
      </div>
      {imageUrl && (
        <div className={styles.image}>
          <img alt="Contact roadside assistance" src={imageUrl} />
        </div>
      )}
    </div>
  );
};

export default ContactRoadside;
